import { VanDesignProvider, useVanDesign } from "./VanDesignContext";
import VanDesignHome from "./VanDesignHome";
import VanDesignIntake from "./VanDesignIntake";
import VanDesignGoals from "./VanDesignGoals";
import VanDesignAIDraft from "./VanDesignAIDraft";
import VanDesignEditor from "./VanDesignEditor";
import VanDesignBlueprint from "./VanDesignBlueprint";
import VanDesign3D from "./VanDesign3D";

const BACK = { intake: "home", goals: "intake", draft: "goals", editor: "draft", blueprint: "editor", "3d": "editor" };

function VanScreens({ onClose }) {
  const { screen, setScreen } = useVanDesign();
  const back = (s) => () => setScreen(BACK[s] || "home");

  if (screen === "intake") return <VanDesignIntake onBack={back("intake")} />;
  if (screen === "goals") return <VanDesignGoals onBack={back("goals")} />;
  if (screen === "draft") return <VanDesignAIDraft onBack={back("draft")} />;
  if (screen === "editor") return <VanDesignEditor onBack={back("editor")} />;
  if (screen === "blueprint") return <VanDesignBlueprint onBack={back("blueprint")} />;
  if (screen === "3d") return <VanDesign3D onBack={back("3d")} />;
  return <VanDesignHome onBack={onClose} />;
}

export default function VanDesignWorkspace({ onBack }) {
  return (
    <VanDesignProvider>
      <VanScreens onClose={onBack} />
    </VanDesignProvider>
  );
}
